export const parameterizedReportList = [
    {
        reportName: 'Audit Appeal/Denial Outcome Summary'
    },
    {
        reportName: 'Audit Financial Results Summary'
    },
    {
        reportName: 'Title Page'
    }
];

export const reportParemeters = [
    {
        reportTitle: 'Audit Appeal/Denial Outcome Summary',
        prompt: [
            {
                id: 'Hide Round level data',
                type: 'checkbox',
                title: 'Hide Round level data',
                label: '',
                selected: false
            },
            {
                id: 'Hide Process Manager',
                type: 'checkbox',
                title: 'Hide Process Manager',
                label: '',
                selected: false
            },
            {
                id: 'Hide cases without a final outcome',
                type: 'checkbox',
                title: 'Hide cases without a final outcome',
                label: '',
                selected: true,
                text: 'Adds text Includes Incomplete Cases Note'
            },
            {
                id: 'Hide Case Final Outcome Pie Chart',
                type: 'checkbox',
                title: 'Hide Case Final Outcome Pie Chart',
                label: '',
                selected: false
            },
            {
                id: 'Hide Final Determination Round Pie Chart',
                type: 'checkbox',
                title: 'Hide Final Determination Round Pie Chart',
                label: '',
                selected: false
            },
        ]
    },
    {
        reportTitle: 'Audit Financial Results Summary',
        prompt: [
            {
                id: 'Hide case level data',
                type: 'checkbox',
                title: 'Hide case level data',
                label: '',
                selected: true
            },
            {
                id: 'Hide Round level data',
                type: 'checkbox',
                title: 'Hide Round level data',
                label: '',
                selected: false
            },
            {
                id: 'Hide PHI',
                type: 'checkbox',
                title: 'Hide PHI',
                label: '',
                selected: true
            },
            {
                id: 'Hide Process Manager',
                type: 'checkbox',
                title: 'Hide Process Manager',
                label: '',
                selected: false
            },
            {
                id: 'Hide cases without a final outcome',
                type: 'checkbox',
                title: 'Hide cases without a final outcome',
                label: '',
                selected: true,
                text: 'Adds text Includes Incomplete Cases Note'
            },
        ]
    },
    {
        reportTitle: 'Title Page',
        prompt: [
            {
                id: 'Hide Process Manager',
                type: 'checkbox',
                title: 'Hide Process Manager',
                label: '',
                selected: false
            },
            {
                id: 'Hide Audit Status',
                type: 'checkbox',
                title: 'Hide Audit Status',
                label: '',
                selected: false
            },
            
        ]
    }
]